<template>
    <div class="loginCon">
      <div class="one" :class="{active:isShow}">
        <p>{{num}}%</p>
        <div class="center">
          <div class="top">
            <div class="square">
              <div class="square">
                <div class="square">
                  <div class="square">
                    <div class="square">
                      <div class="square">

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="square">
              <div class="square">
                <div class="square">
                  <div class="square">
                    <div class="square">
                      <div class="square">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left">
            <div class="square">
              <div class="square">
                <div class="square">
                  <div class="square">
                    <div class="square">
                      <div class="square">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="square">
              <div class="square">
                <div class="square">
                  <div class="square">
                    <div class="square">
                      <div class="square">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span v-if="!isShow" ></span >
      <div class="three" :class="{activeT:isShow}">
        <img class="animated fadeInUp" src="../assets/ycb/topLogo.png" alt="">
      </div>

    </div>
</template>

<script>
    export default {
        name: "login",
      data(){
          return{
            num:0,
            se:0,
            isShow:false,
          }
      },
      mounted(){
        this.$store.state.showTop=false
          let time=setInterval(()=>{
            this.num++
            this.se++
            if(this.num==100){
              this.isShow=true
              clearInterval(time)
            }
          },30)
          setTimeout(()=>{
             const link='./home.html'
            window.open(link,'_self')
          },4000)
      }
    }
</script>

<style scoped>
  .square {
    width: 4px;
    height: 10px;
    background: #EEA25D;
    border-radius: 10px;
    /*margin:10px;*/

    display: block;
    -webkit-animation: turn 2.5s ease infinite;
    animation: turn 2.5s ease infinite;
  }
  .top {
    position: absolute;
    left: 40%;
    top: 50%;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .bottom {
    position: absolute;
    left: 40%;
    top: 50%;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .left {
    position: absolute;
    left: 40%;
    top: 50%;
  }
  .right {
    position: absolute;
    left: 40%;
    top: 50%;
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }
  @-webkit-keyframes turn {
    0% {
      transform: translateX(0) translateY(0) rotate(0);
    }
    50% {
      transform: translateX(400%) translateY(100%) rotate(90deg);
    }
    100% {
      transform: translateX(0) translateY(0) rotate(0);
    }
  }
  @keyframes turn {
    0% {
      transform: translateX(0) translateY(0) rotate(0);
    }
    70% {
      transform: translateX(400%) translateY(100%) rotate(90deg);
    }
    100% {
      transform: translateX(0) translateY(0) rotate(0);
    }
  }
</style>
<style lang="scss" scoped>
.loginCon{
  width:100%;
  height:100vh;
  overflow: hidden;
  background-color: black;
  .one{
    width:100%;
    height:48%;
    position: relative;
    p{
      text-align: center;
      color:white;
      position: absolute;
      bottom:30px;
      left:48%;
    }
    .center{
      position: absolute;
      left:49%;
      bottom:10px;
    }
  }
  span{
    display: inline-block;
    width:100%;
    height:1px;
    background-color: rgba(99, 99, 99, 1);
    animation-name:mymove;
    animation-duration:3s;
    /*Safari 和 Chrome*/
    -webkit-animation:mymove 3s ;
    animation-fill-mode: forwards;
    position: absolute;
    left:0;
  }
  @keyframes myMove {
    from {width:0;}
    to {width:100%;}
  }
  @-webkit-keyframes mymove /*Safari 和 Chrome*/{
    from {width:0;}
    to {width:100%;}
  }
  .three{
    width:100%;
    height:48%;
    position: relative;
    img{
      position: absolute;
      top: 40px;
      left: 43%;
    }
  }

  .active{
    transition: 1s;
    transform: translateY(-120%);
  }
  .activeT{
    transition: 1s;
    transform: translateY(110%);
  }
  @media screen and (min-width:1921px){
    .one{
      p{
        left:47.5%;
      }
      .center{
        left:48%;
      }
    }
 .three{
   img{
     left: 44%;
   }
 }
  }
  @media screen and (max-width:1366px){
    .three{
      img{
        left: 42%;
      }
    }
  }
  @media screen and (max-width:450px){
    .three{
      img{
        left: 26%;
      }
    }
  }
}
</style>
